import "./aiimageselector.scss";
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import ModalComponent from "../ModalComponent";
import Image from "../Image/image";
function AiImageSelector(props) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const handleClose = (show) => {
    props.setShowImageSelector(show);
  };

  const handleSelectOption = (element, imageUrl) => {
    setSelectedOption(element);
    setSelectedImage(imageUrl);
  };

  const handleSelect = () => {
    props.onSelect(selectedImage);
    handleClose(false);
  };

  const fillEmptySpots = () => {
    const emptyDivs = [];
    const missingImagesLen = 9 - props.images.length;
    for (let i = 0; i < missingImagesLen; i++) {
      emptyDivs.push(
        <Col md={4} key={`empty_${i}`}>
          <div style={{ width: "auto", radius: "20px", height: "200px" }} />
        </Col>
      );
    }

    return <>{emptyDivs}</>;
  };

  const content = (
    <Container className="ai-image-selector-container">
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div className="ai-image-selector-content">
          {props.images
            .sort((a, b) => b.id - a.id)
            .slice(0, 9)
            .map((x, index) => {
              return (
                <Col md={4} key={index} className={`option ${selectedOption === index ? "selected" : ""}`} onClick={() => handleSelectOption(index, x.message)}>
                  <input type="radio" name="option" />
                  <Image src={x.message} width={"auto"} radius={20} height={200} />
                </Col>
              );
            })}
          {}
          {fillEmptySpots()}
          <div className="ai-image-selector-buttons">
            <Button type="button" variant="secondary" className="ai-image-selector-button" onClick={() => handleClose(false)}>
              Cancel
            </Button>
            <Button type="button" className="ai-image-selector-button" disabled={!selectedImage} onClick={handleSelect}>
              Select
            </Button>
          </div>
        </div>
      </div>
    </Container>
  );

  const closeContainerStyle = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    width: 40,
    height: 40,
    backgroundColor: "#F3F5F7",
    position: "absolute",
    marginTop: 20,
    marginRight: -690,
    borderRadius: 40,
  };
  return (
    <ModalComponent
      styleCloseContainer={closeContainerStyle}
      className="modal-container"
      data={content}
      modalIsOpen={props.showImageSelector}
      setModalIsOpen={handleClose}
      showCloseText={false}
    />
  );
}

export default AiImageSelector;
